import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import QueryWorkitem from "../../../../../modules/@cloudpivot/flow-center/src/components/pc/components/query-condition/query-workitem.vue";
import StaffSelector from "../../../../../modules/@cloudpivot/form/src/common/components/form-staff-selector/pc/staff-selector.vue";
import ExpatHomePage from "../expats/homePage.vue";
import ExitHomePage from "../exit/homePage.vue";
// import OdHomePage from "../OD/homePage.vue";
import OdHomePage from "./odHomepage.vue";
import MobilityHomePage from '../mobility/homePage.vue';
import MyModal from "../components/modal.vue";
import onboardingHome from "../Onboarding/onboarding-home.vue";
import { Badge, Table, Carousel, Form, Row, Col, Input, Select, DatePicker, Button, Modal, Cascader, Tree, Icon, Pagination, } from "@h3/antd-vue";
import Axios from "axios";
import unCompleteBm from "../../../src/views/workflow-center/workbenchInfo/workbenchComponents/unCompleteBm.vue";
import encryptApi from "@cloudpivot/common/src/utils/aes/index";
let supervise = class supervise extends Vue {
    constructor() {
        super(...arguments);
        this.isShowModal = false;
        //待办数量
        this.count = {};
        //Contact_infomation数据
        this.contactList = {};
        this.dataList = [];
    }
    hideItem(item) {
        let userStr = window.sessionStorage.getItem("user");
        let userRole = userStr && JSON.parse(userStr).roleIds || [];
        if (item.isRoleList) {
            let settingRole = item.roleList && item.roleList.split(',') || [];
            // let isShow = userRole.indexOf(settingRole) > -1;
            // return !isShow;
            const set1 = new Set(userRole);
            const set2 = new Set(settingRole);
            let intersect = new Set([...set1].filter(e => set2.has(e)));
            return !(intersect.size > 0);
        }
        else {
            let isCertificateSSC = userRole.indexOf("SYS230512094328196") > -1;
            if (item.appchirdenName === "All Application List") {
                return !isCertificateSSC;
            }
            else {
                return false;
            }
        }
    }
    get apiHost() {
        return window.config.apiHost;
    }
    get token() {
        return window.localStorage.getItem("token");
    }
    get appCode() {
        return this.$route.params.appCode;
    }
    created() {
        this.getWorkCount();
        this.getAppList();
        this.getContactList();
    }
    showModal() {
        this.isShowModal = true;
    }
    changeModal() {
        this.isShowModal = false;
    }
    getWorkCount() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield Axios.get(`/api/runtime/workflow/get_work_count?appCode=`);
            if (res.errcode === 0) {
                this.count = res.data;
            }
        });
    }
    // 获取app列表
    getAppList() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = window.location.href;
            let index = url.indexOf("/");
            // let c = url.substring(index + 2, url.length);
            let urlArr = url.substring(index + 2, url.length).split("/");
            let code = urlArr[2];
            let parmas = {
                filters: [],
                mobile: false,
                page: 0,
                queryCode: "appAlls",
                schemaCode: "appAlls",
                size: 999,
            };
            let res = yield Axios.post(`/api/runtime/query/list`, parmas);
            if (res.errcode === 0) {
                res.data.content.forEach((item) => {
                    if (code === item.data.appsCode) {
                        this.dataList.push(item);
                    }
                });
            }
        });
    }
    querylist(queryCode, schemaCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let parmas = {
                filters: [],
                mobile: false,
                page: 0,
                queryCode: queryCode,
                schemaCode: schemaCode,
                size: 20,
            };
            let res = yield Axios.post("/api/runtime/query/list", parmas);
            return res;
        });
    }
    createList(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            debugger;
            // certificate模块 按钮有权限要求单独处理
            if (data && data.appsCode === "certificate") {
                let userStr = window.sessionStorage.getItem("user") || '';
                let userObj = JSON.parse(userStr);
                let userArr = userObj.roleName ? userObj.roleName.split(",") : [];
                // 当前登录人有 Certificate-SSC发起人 进入NewApplicationTwo列表，否则按原有逻辑执行
                if (userArr.indexOf('Certificate-SSC发起人') > -1) {
                    window.open(`/application/${data.appsCode}/application-list/NewApplicationTwo?HomePageMessage=1`, "_self");
                }
                else {
                    window.open(`/application/${data.appsCode}/application-list/${data.appchirdenCode}?HomePageMessage=1`, "_self");
                }
            }
            else if (data && data.appsCode === "new_Chop") {
                let res = yield this.querylist("new_Chope", "new_chop");
                if (res.errcode === 0) {
                    window.open(`/application/${data.appsCode}/application-list/${data.appchirdenCode}?HomePageMessage=1`, "_self");
                }
                else {
                    this.$message.warning("You have no permission, please apply for permission in 'BPM Platform Account Application / NSC CHC Chop System Authority Application'");
                }
            }
            else {
                window.open(`/application/${data.appsCode}/application-list/${data.appchirdenCode}?HomePageMessage=1`, "_self");
            }
            // window.open(
            //   `/form/detail?schemaCode=${data.appchirdenCode}&sheetCode=null&queryCode=${data.appchirdenCode}`
            // );
        });
    }
    viewList(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (data.outerChain === 'Yes') {
                window.open(data.outerChainURL);
            }
            else {
                if (data && data.appsCode === "certificate") {
                    let userStr = window.sessionStorage.getItem("user") || '';
                    let userObj = JSON.parse(userStr);
                    let userArr = userObj.roleName ? userObj.roleName.split(",") : [];
                    if (userArr.indexOf('Certificate-SSC发起人') > -1 && data.appchirdenCode === "NewApplicationOne") {
                        window.open(`/application/${data.appsCode}/application-list/NewApplicationTwo`, "_self");
                    }
                    else {
                        window.open(`/application/${data.appsCode}/application-list/${data.appchirdenCode}`, "_self");
                    }
                }
                else if (data && data.appsCode === "new_Chop") {
                    let res = yield this.querylist("new_Chope", "new_chop");
                    if (res.errcode === 0) {
                        window.open(`/application/${data.appsCode}/application-list/${data.appchirdenCode}`, "_self");
                    }
                    else {
                        this.$message.warning("You have no permission, please apply for permission in 'BPM Platform Account Application / NSC CHC Chop System Authority Application'");
                    }
                }
                else {
                    window.open(`/application/${data.appsCode}/application-list/${data.appchirdenCode}`, "_self");
                }
                // location.replace(
                //   `/application/${data.appsCode}/application-list/${data.appchirdenCode}`
                // );
            }
        });
    }
    //获取联系信息
    getContactList() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = window.location.href;
            let index = url.indexOf("/");
            // let c = url.substring(index + 2, url.length);
            let urlArr = url.substring(index + 2, url.length).split("/");
            let code = urlArr[2];
            let parmas = {
                filters: [
                    {
                        propertyCode: "appsCode",
                        propertyType: 14,
                        propertyValue: code,
                        propertyValueName: "",
                    },
                ],
                mobile: false,
                page: 0,
                queryCode: "contactList",
                schemaCode: "contactList",
                size: 999,
            };
            let res = yield Axios.post("/api/runtime/query/list", parmas);
            if (res.errcode === 0) {
                res.data.content.forEach((item) => {
                    if (code === item.data.appsCode) {
                        this.contactList = item.data;
                    }
                });
            }
        });
    }
    //获取图片地址
    getDownloadUrl(refId) {
        const KEY = window.config.encrypt_totalRewards.KEY;
        const IV = window.config.encrypt_totalRewards.IV;
        let url = `${this.apiHost}/api/aliyun/download?refId=${encodeURIComponent(encryptApi.encrypt_iv(refId, KEY, IV))}`;
        if (this.token) {
            url += "&T=" + encodeURIComponent(encryptApi.encrypt_iv(this.token, KEY, IV));
        }
        return url;
    }
    closeIframeForm(type) {
        if (["draft", "shortcut", "unfinish"].includes(type)) {
            // @ts-ignore
            this.$refs.statistics.getWorkflowStatistics();
            // @ts-ignore
            this.$refs.myDraft.getList();
        }
    }
};
supervise = tslib_1.__decorate([
    Component({
        name: "supervise",
        components: {
            unCompleteBm,
            MyModal: MyModal,
            StaffSelector,
            QueryWorkitem,
            ABadge: Badge,
            ATable: Table,
            ACarousel: Carousel,
            AForm: Form,
            AFormItem: Form.Item,
            ARow: Row,
            ACol: Col,
            AInput: Input,
            AInputSearch: Input.Search,
            ASelect: Select,
            ASelectOption: Select.Option,
            ADatePicker: DatePicker,
            AButton: Button,
            AModal: Modal,
            ACascader: Cascader,
            ADirectoryTree: Tree.DirectoryTree,
            AIcon: Icon,
            APagination: Pagination,
            ExpatHomePage,
            ExitHomePage,
            MobilityHomePage,
            OdHomePage,
            onboardingHome
        },
    })
], supervise);
export default supervise;
